import { useContext, useState } from "react";
import { ensure } from "sprint-common-web";

import { useManzanitaPresetApi } from "../../../../../common/api/orders-api/manzanita-preset/useManzanitaPresetApi";
import { blobToBase64 } from "../../../../../orders/orders/common/blobToBase64";
import { ManzanitaPresetListingContext } from "../../context/ManzanitaPresetListingContext";
import { CreateManzanitaPresetFormInputs } from "./CreateManzanitaPresetForm";

export const useCreateManzanitaPresetForm = () => {
    const { createManzanitaPreset: createPreset } = useManzanitaPresetApi();
    const { addItem } = useContext(ManzanitaPresetListingContext);
    const [droppedFile, setDroppedFile] = useState<File>();
    const [isFileDropped, setIsFileDropped] = useState<boolean>(false);

    const dropFile = (file: File) => {
        setDroppedFile(file);
        setIsFileDropped(true);
    };

    const clearFile = () => {
        setIsFileDropped(false);
        setDroppedFile(undefined);
    };

    const createManzanitaPreset = async ({ name }: CreateManzanitaPresetFormInputs) => {
        ensure(droppedFile);

        const encodedPresetFile = await blobToBase64(droppedFile);

        const response = await createPreset({
            name,
            filePath: droppedFile.name,
            encodedFile: encodedPresetFile
        });

        addItem({
            id: response.entityId,
            name,
            filePath: droppedFile.name,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        createManzanitaPreset,
        dropFile,
        clearFile,
        isFileDropped,
        droppedFile
    };
};
